export enum BoxAvailability {
  inStock = 'inStock',
  lowStock = 'lowStock',
  outOfStock = 'outOfStock',
}

export function getBoxAvailabilityFromString(
  value?: BoxAvailability
): BoxAvailability {
  if (!value) {
    return BoxAvailability.inStock;
  }

  switch (value) {
    case 'inStock':
      return BoxAvailability.inStock;
    case 'lowStock':
      return BoxAvailability.lowStock;
    case 'outOfStock':
      return BoxAvailability.outOfStock;
    default:
      throw new Error(`Unknown BoxAvailability value: ${value}`);
  }
}
